module.exports = __webpack_public_path__ + "img/ic_job_history.4981fceb.svg";